import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  // Close mobile menu when location changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="container-fluid nav-bar p-0">
      <nav className="navbar navbar-expand-lg navbar-light bg-white px-4 px-lg-5 py-3 py-lg-0">
        <Link to="/" className="navbar-brand p-0">
          <div className="text-center">
            <h1 className="display-5 text-secondary m-0">
              <img src="/assets/img/brand-logo.png" className="img-fluid" alt="" />
            </h1>
            <p className="text-secondary mb-0 mt-1 d-none d-md-block" style={{
              fontSize: '0.9rem',
              fontWeight: '400',
              fontStyle: 'italic',
              lineHeight: '1.2'
            }}>
              Something is more than Success that is Satisfaction
            </p>
            <p className="text-secondary mb-0 mt-1 d-block d-md-none" style={{
              fontSize: '0.65rem',
              fontWeight: '400',
              fontStyle: 'italic',
              lineHeight: '1.0'
            }}>
              Something is more than Success that is Satisfaction
            </p>
          </div>
        </Link>
        <button 
          className={`navbar-toggler ${isMobileMenuOpen ? '' : 'collapsed'}`}
          type="button" 
          onClick={toggleMobileMenu}
          aria-controls="navbarCollapse"
          aria-expanded={isMobileMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="fa fa-bars"></span>
        </button>
        <div className={`navbar-collapse ${isMobileMenuOpen ? 'show' : 'collapse'}`} id="navbarCollapse">
          <div className="navbar-nav ms-auto py-0">
            <Link to="/" className={`nav-item nav-link ${isActive('/')}`}>Home</Link>
            <Link to="/about" className={`nav-item nav-link ${isActive('/about')}`}>About</Link>
            <div className="nav-item dropdown">
              <Link
                to="#"
                className="nav-link" 
                onClick={toggleDropdown}
                onMouseEnter={() => window.innerWidth >= 992 && setIsDropdownOpen(true)}
                onMouseLeave={() => window.innerWidth >= 992 && setIsDropdownOpen(false)}
              >
                <span className="dropdown-toggle">Service</span>
              </Link>
              <div className={`dropdown-menu m-0 ${isDropdownOpen ? 'show' : ''}`}>
                <Link to="/immigration" className="dropdown-item">Immigration</Link>
                <Link to="/business-setup" className="dropdown-item">Business Setup</Link>
                <Link to="/business-support" className="dropdown-item">Business Support</Link>
              </div>
            </div>
            <Link to="/contact" className={`nav-item nav-link ${isActive('/contact')}`}>Contact</Link>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar; 